import { useEffect, useState } from "react";
import "./Style.css";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import {
  Button,
  Form,
  Card,
  Spinner,
  Breadcrumb,
  Row,
  Col,
  Modal,
} from "react-bootstrap";

export default function EditCustomer({
  showEdit,
  closeModal,
  refreshPage,
  userDetails,
}) {
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [customer, setCustomer] = useState([]);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    country: "",
    turnover: "",
    state: "",
    city: "",
    area: "",
    status: "",
    customer_code: "",
    password: "",
  });

  const resetForm = () => {
    setFormData({
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      country: "",
      turnover: "",
      state: "",
      city: "",
      area: "",
      status: "",
      customer_code: "",
      password: "",
    });
    setValidationError({});
  };

  useEffect(() => {
    if (userDetails) {
      setFormData({
        first_name: userDetails?.first_name || "",
        last_name: userDetails?.last_name || "",
        email: userDetails?.email || "",
        phone: userDetails?.phone || "",
        country: userDetails?.country || "",
        turnover: userDetails?.turnover || "",
        state: userDetails?.state || "",
        city: userDetails?.city || "",
        area: userDetails?.area || "",
        customer_code: userDetails?.customer_code || "",
        password: userDetails?.password || "",

        // role: userDetails.roles[0]?.name || "",
        // user_type_name: userDetails.userType?.user_type_name || "",
      });
      // if (userDetails.roles.length > 0) {
      //   setSelectedRole(userDetails.roles[0].id);
      //   setSelectedUser(userDetails.user_type_id);

      // }
    }
  }, [userDetails]);

  const handleChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClose = () => {
    // resetForm();
    closeModal();
  };

  //   const handleClose = () => {
  //     resetForm();
  //     closeModal();
  //   }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Extract the role ID from the selectedRole state
      const response = await axiosInstance.post(
        `/user/customer/edit_customer`,
        {
          id: userDetails.customer_id,
          user_id: userDetails.user_id,
          first_name: formData.first_name,
          last_name: formData.last_name,
          phone: formData.phone,
          country: formData.country,
          state: formData.state,
          area: formData.area,
          city: formData.city,
          // customer_code: formData.customer_code,
          turnover: formData.turnover,
        }
      );

      if (response.data.success) {
        // Handle successful response, e.g., show success message
        toast.success("Customer updated successfully!");
        refreshPage();
        handleClose(); // Close the modal
      } else {
        // Handle errors, e.g., show error messages
        console.error("Update failed:", response.data.message);
      }
    } catch (error) {
      console.error("An error occurred while updating the user:", error);
      toast.error("Failed to Update user.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="CreateCSP">
      <Modal show={showEdit} onHide={handleClose} dialogClassName="modal-lg">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Edit New Customer Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <Form.Label>Name</Form.Label> */}
            <Row>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formBasicname">
                  <div>
                    <h6>First Name</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                  />
                  {validationError.first_name && (
                    <small className="text-danger my-1">
                      {" "}
                      {validationError.first_name[0]}{" "}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formBasicname">
                  <div>
                    <h6>Last Name</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                  />
                  {validationError.last_name && (
                    <small className="text-danger my-1">
                      {" "}
                      {validationError.last_name[0]}{" "}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formEmail">
                  <div>
                    <h6>Email</h6>
                  </div>
                  <Form.Control
                    type="email"
                    placeholder="Enter..."
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    readOnly
                    style={{ backgroundColor: "#f0f0f0", color: "#6c757d" }}
                  />
                  {validationError.email && (
                    <small className="text-danger my-1">
                      {" "}
                      {validationError.email[0]}{" "}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formPhone">
                  <div>
                    <h6>Phone Number</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                  {validationError.phone && (
                    <small className="text-danger my-1">
                      {" "}
                      {validationError.phone[0]}{" "}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formPhone">
                  <div>
                    <h6>Turnover</h6>
                  </div>
                  <Form.Control
                    type="number"
                    placeholder="Enter..."
                    name="turnover"
                    value={formData.turnover}
                    onChange={handleChange}
                  />
                  {validationError.turnover && (
                    <small className="text-danger my-1">
                      {" "}
                      {validationError.turnover[0]}{" "}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <div>
                    <h6>Country</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                  />
                  {validationError.country && (
                    <small className="text-danger my-1">
                      {validationError.country[0]}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <div>
                    <h6>State</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                  />
                  {validationError.state && (
                    <small className="text-danger my-1">
                      {validationError.state[0]}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <div>
                    <h6>City</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                  />
                  {validationError.city && (
                    <small className="text-danger my-1">
                      {validationError.city[0]}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <div>
                    <h6>Area</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="area"
                    value={formData.area}
                    onChange={handleChange}
                  />
                  {validationError.area && (
                    <small className="text-danger my-1">
                      {validationError.area[0]}
                    </small>
                  )}
                </Form.Group>
              </Col>
              {/* <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <div>
                    <h6>Customer ID</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="customer_code"
                    value={formData.customer_code}
                    onChange={handleChange}
                  />
                  {validationError.customer_code && (
                    <small className="text-danger my-1">
                      {validationError.customer_code[0]}
                    </small>
                  )}
                </Form.Group>
              </Col> */}
            </Row>

            {/* <Form.Group className="mb-3" controlId="formPhone">
              <div>
                <h6>Contact Person Number</h6>
              </div>
              <Form.Control
                type="number"
                placeholder="Enter..."
                name="phone"
                value={formData.contactPersonNumber}
                onChange={handleChange}
              />
              {validationError.contactPersonNumber && (
                <small className="text-danger my-1">
                  {" "}
                  {validationError.contactPersonNumber[0]}{" "}
                </small>
              )}
            </Form.Group> */}
          </Modal.Body>
          <Modal.Footer>
            {/* <Button variant="link" onClick={handleClose}>
              Close
            </Button> */}
            <Button
              className=""
              style={{
                backgroundColor: "#c4281b",
                color: "#fff",
                border: "none",
              }}
              type="submit"
            >
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* <ToastContainer /> */}
    </div>
  );
}
